import type { ReturnMode } from "@babackapp/return-widget-components/types";

export type ReturnModeAvailability = {
  hasCarrier: boolean;
  hasStoreReturns: boolean;
  hasRetractation: boolean;
  hasExchangeItem: boolean;
  isMerchant: boolean;
};

const RETURN_MODE_ORDER: ReturnMode[] = ["carrier", "store", "retractation"];

/**
 * Modes offered on the return-mode screen, in display order. The first one is
 * the form default, so the list never comes back empty.
 *
 * Without a carrier the carrier mode sends the customer off with no label,
 * which is what the retractation mode does while also flagging the return as a
 * retractation (14-day window, eligible country). The retractation mode then
 * takes its place (BBS-385). With neither, the carrier mode stays: it is the
 * only way to ship the parcel back.
 */
export function resolveReturnModes({
  hasCarrier,
  hasStoreReturns,
  hasRetractation,
  hasExchangeItem,
  isMerchant,
}: ReturnModeAvailability): ReturnMode[] {
  const isOffered: Record<ReturnMode, boolean> = {
    carrier: hasCarrier || !hasRetractation,
    store: hasStoreReturns && (!hasExchangeItem || isMerchant),
    retractation: hasRetractation,
  };
  return RETURN_MODE_ORDER.filter((mode) => isOffered[mode]);
}
